<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    :width="isEnglish ? '468px': '428px'"
    class="ocpc-record-info-madol "
    :mask-closable="false"
    :footer="null"
    @cancel="TipDialogVisible=false"
  >
    <div
      slot="title"
      class="ocpc-modal-tit clearfix"
    >
      <h2>
        {{ $t('message["1865"]') }}
      </h2>
      <a-tag :color="typeStatus.color">
        {{ typeStatus.txt }}
      </a-tag>
    </div>
    <div
      class="record-info-box scroll_bar_beautify_ff"
      :class="{'en-record-info-box': isEnglish}"
    >
      <a-form :form="form">
        <h3 class="ocpc-record-item-tit">
          {{ $t('message["1876"]') }}
        </h3>
        <a-form-item>
          <template slot="label">
            {{ $t('message["1831"]') }}
          </template>
          {{ itemData.inquirycode }}
          <a
            href="javascript:;"
            class="ml-16"
            @click="toInquiryInfo"
          >{{ $t('message["85"]') }}</a>
        </a-form-item>
        <a-form-item>
          <template slot="label">
            {{ $t('message["1832"]') }}
          </template>
          {{ itemData.adid }}
        </a-form-item>
        <a-form-item>
          <template slot="label">
            {{ $t('message["1835"]') }}
          </template>
          {{ channelType[itemData.type - 1] || '--' }}
        </a-form-item>
        <a-form-item>
          <template slot="label">
            {{ $t('message["1836"]') }}
          </template>
          {{ itemData.addtime > 0 ? $moment(itemData.addtime * 1000).format('YYYY-MM-DD HH:mm:ss') : '--' }}
        </a-form-item>
        <h3 class="ocpc-record-item-tit">
          {{ $t('message["1871"]') }}
        </h3>
        <a-form-item>
          <template slot="label">
            {{ $t('message["1872"]') }}
          </template>
          {{ configInfo.status }}
        </a-form-item>
        <a-form-item>
          <template slot="label">
            {{ $t('message["1358"]') }}
          </template>
          {{ configInfo['info_level'] }}
        </a-form-item>
        <a-form-item>
          <template slot="label">
            {{ $t('message["1372"]') }}
          </template>
          {{ configInfo['info_type'] }}
        </a-form-item>
        <a-form-item>
          <template slot="label">
            {{ $t('message["375"]') }}
          </template>
          {{ configInfo['info_status'] }}
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex'
import { getLang } from '@/lib/storage'
export default {
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState('config/ocpc', ['channelType']),
    modalTit () {
      return this.$t('message["1037"]')
    },
    typeStatus () {
      const isSuc = this.itemData.status * 1
      let typeColor = {}
      if (isSuc === 1) {
        typeColor = { color: '#42C27E', txt: this.$t('message["1860"]') }
      } else if (isSuc === 2) {
        typeColor = { color: '#F57676', txt: this.$t('message["1829"]') }
      } else {
        typeColor = { color: '#4CA0F2', txt: this.$t('message["1878"]') }
      }
      return typeColor
    },
    configInfo () {
      const { config = {} } = this.itemData
      return config
    },
    pid () {
      return this.$store.state.pid
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  watch: {
  },
  methods: {
    getLang,
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    toInquiryInfo () {
      const { itemData } = this
      this.$router.push({
        // path: `/project/${this.pid}/inquery/detail/${inquiryid}`,
        name: itemData.inquirystatus === 1 ? 'InqueryPassDetail' : 'InqueryDetail',
        params: {
          pid: this.pid,
          inquiryId: itemData.inquiryid
        },
        query: {
          from: 'ocpc'
        }
      })
    }

  }
}
</script>
<style lang="scss" scoped>
  .record-info-box::v-deep{
    max-height: 480px;
    overflow: auto;
    .ant-row {
        padding-left: 100px;
        margin-bottom: 8px;
        .ant-form-item-label {
          float: left;
          width: 90px;
          margin-left: -100px;
          color: #666;
          text-align: right;
        }
        .ant-form-item-control-wrapper {
          float: left;
          width: 100%;
        }
      }
    .ocpc-record-item-tit{
      font-weight: 500;
      margin-bottom: 10px;
    }
  }
  .en-record-info-box::v-deep {
    .ant-row {
      padding-left: 140px;
      .ant-form-item-label {
          float: left;
          width: 130px;
          margin-left: -140px;
          color: #666;
          text-align: right;
        }
    }
  }
</style>
<style lang="scss">
.ocpc-record-info-madol .ant-modal-body{
  padding-left: 40px !important;
}
  .ocpc-modal-tit {
    h2 {
      float: left;
      margin-right: 10px;
      font-size: 18px;
    }
    .ant-tag {
      float: left;
      cursor: default;
    }
  }
</style>
